import AnimatedLine, { AnimatedLineConfig } from "./AnimatedLine";

const config: AnimatedLineConfig = {
    viewBox: "0 0 525 282",
    path: "M0.464844 281.17C83.2548 69.8602 486.604 105.405 524.465 0.169922",
    dashArray: "2.31 2.31",
    dots: [
        { cx: 40.465, cy: 217.73, r: 8, delay: 0.5 },
        { cx: 200.465, cy: 124.417, r: 8, delay: 1.0 },
        { cx: 499.465, cy: 30.412, r: 8, delay: 1.5 },
    ],
    gradient: { x: 262.465, y1: 0.169922, y2: 281.17 },
};

const Line5 = ({ className }: { className?: string }) => (
    <AnimatedLine {...config} className={className} />
);

export default Line5;
